module.exports = __webpack_public_path__ + "img/9.7f0a3f71.jpg";